import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight, Sparkles } from 'lucide-react';

const MegaServices = ({ grouped, totalCount, onEnter, onLeave }) => (
  <div
    data-testid="mega-services"
    onMouseEnter={onEnter}
    onMouseLeave={onLeave}
    className="hidden lg:block absolute left-0 right-0 top-full bg-gradient-to-b from-white via-gray-50 to-gray-100 border-y border-gray-200 shadow-2xl shadow-gray-400/30 animate-fadeIn"
  >
    <div className="max-w-[1400px] mx-auto px-6 py-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-orange-500 text-[10px] uppercase tracking-[0.25em] font-bold mb-0.5">Capabilities</div>
          <h3 className="text-[#0e1116] text-xl font-black">Our Engineering <span className="text-green-600">Services</span></h3>
        </div>
        <Link to="/services" className="hidden md:inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-gray-600 hover:text-green-600" data-testid="mega-services-explore">
          Explore all services <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3 normal-case">
        {Object.entries(grouped).map(([cat, list]) => (
          <div key={cat} className="min-w-0">
            <div className="flex items-center gap-1.5 text-orange-500 font-bold text-[10px] uppercase tracking-wider mb-2 pb-1.5 border-b border-gray-200">
              <Icons.FolderKanban className="w-3 h-3" /> <span className="truncate">{cat}</span>
            </div>
            <ul className="space-y-2">
              {list.map(s => {
                const Ic = Icons[s.icon] || Icons.Box;
                return (
                  <li key={s.slug}>
                    <Link
                      to={`/services/${s.slug}`}
                      className="group block px-1.5 py-1.5 rounded hover:bg-white hover:shadow-sm transition-colors"
                      data-testid={`mega-svc-${s.slug}`}
                    >
                      <div className="flex items-center gap-1.5 text-[#0e1116] text-[12px] font-bold group-hover:text-green-600 leading-tight">
                        <Ic className="w-3 h-3 text-orange-500 group-hover:text-orange-600 shrink-0" />
                        <span className="truncate">{s.title}</span>
                      </div>
                      <p className="text-[10px] text-gray-500 mt-1 leading-snug line-clamp-2 group-hover:text-orange-600">
                        {s.short}
                      </p>
                      <span className="inline-flex items-center gap-0.5 mt-1 text-[9px] font-bold uppercase tracking-wider text-green-600 group-hover:text-orange-500">
                        Know more <ArrowRight className="w-2 h-2" />
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
      <div className="pt-3 mt-4 border-t border-gray-200 flex items-center justify-between text-xs text-gray-500">
        <span className="flex items-center gap-2"><Sparkles className="w-3.5 h-3.5 text-orange-500" /> {totalCount} expert services across {Object.keys(grouped).length} disciplines</span>
        <Link to="/get-quote" className="text-orange-500 hover:text-orange-600 font-bold uppercase tracking-wider">Request a quote →</Link>
      </div>
    </div>
  </div>
);

export default MegaServices;
